<template>
    <div class="panel panel-info">
        <!-- Default panel contents -->
        <div class="panel-heading">LOCALIZAÇÃO DO CLIENTE NO MAPA </div>
        <div class="panel-body" id="map" style="height: 200px">
            <v-map :zoom="15" :center="[geocode.latitude, geocode.longitude]" >
                <v-tilelayer url="https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"/>
                <v-marker :key="nome" :lat-lng="[geocode.latitude, geocode.longitude]" >
                    <v-popup :content="nome"/>
                    <v-tooltip :content="nome"/>
                </v-marker>
            </v-map>
        </div>
    </div>
</template>
<script>
export default {
    props: ["geocode", "nome"]
};
</script>
